import React from "react";
import { SessionStore } from "../uidispatcherapi/SessionStore";
import { wrapLazyComponent } from "../lazy-loading/lazyWrapper";
const LogoutPopup = wrapLazyComponent(() => import("cia_ui/LogoutPopup"));
type StateType = {
	showPopup: boolean;
};

class LogoutPopupWrapper extends React.Component<Record<PropertyKey, never>, StateType> {
	unsubscribe: (() => void) | null;

	constructor(props) {
		super(props);
		this.state = {
			showPopup: false,
		};
		this.unsubscribe = null;
	}

	componentDidMount(): void {
		this.unsubscribe = SessionStore.listen(state => this.onSessionStoreChange(state));
	}

	componentWillUnmount(): void {
		if (this.unsubscribe) {
			this.unsubscribe();
			this.unsubscribe = null;
		}
	}

	onSessionStoreChange(state: Record<string, any>): void {
		this.setState({
			showPopup: state.waitingForIdamLogout,
		});
	}

	render(): any | null {
		if (this.state.showPopup) {
			return <LogoutPopup />;
		}

		return null;
	}
}

export default LogoutPopupWrapper;
